/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2021-11-30 10:08:21
 * @Description: 
 */
import constUrl from "../constant/url"
import deeplink from "../constant/deeplinkMobile"
import urls from "../constant/url";
import { FTGetImageUrl, FTUserProfile } from "src/server/api";
import { default as defaultAxios } from "axios";

export enum LANGUAGE_TYPE {
  ZH_CN = 'zh_CN',
  ZH_TW = 'zh_TW',
  EN_US = 'en_US',
  ES_ES = 'es_ES',
  PT_BR = 'pt_BR',
  RU_RU = 'ru_RU',
  FR_FR = 'fr_FR',
  DE_DE = 'de_DE',
  JA_JP = 'ja_JP',
}
interface uploadProps {
  accept?: string;
  multiple?: boolean;
}

interface Size {
  width: number,
  height: number
}

const utils = {
  
  loadJsScript(url: string): Promise<void> {
    return new Promise(async (resolve, reject) => {
      const bodyScript = document.createElement("script");
      bodyScript.setAttribute("src", url);
      bodyScript.defer = true;
      bodyScript.onload = function onLoad() {
        resolve();
      };
      bodyScript.onerror = function onLoad() {
        resolve();
      };
      document.head.appendChild(bodyScript);
    });
  },
  loadPaymentSdk() :Promise<void>{
    return new Promise((resolve, reject) => {
      if (window.Payment) {
        resolve();
      } else {
        const bodyScript = document.createElement("script");
        bodyScript.setAttribute("src", constUrl.paymentSdk as string);
        bodyScript.onload = function() {
          resolve();
        };
        document.body.appendChild(bodyScript);
      }
    });
  },
  loadLoginScript() :Promise<void> {
    return new Promise((resolve, reject) => {
      if (window.login) {
        resolve();
      } else {
        const bodyScript = document.createElement("script");
        bodyScript.setAttribute(
          "src",
          constUrl.loginSdk as string
        );
        bodyScript.onload = function() {
          resolve();
        };
        document.body.appendChild(bodyScript);
      }
    });
  },

  myBrowserOS() {
    let u = navigator.userAgent;
    let uLower = navigator.userAgent.toLowerCase();
    return {
      //移动终端浏览器版本信息
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或uc浏览器
      iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
      mac: u.indexOf("Mac") > -1, //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf("iPad") > -1, //是否iPad
      isMobile: /Android|webOS|iPhone|iPod|BlackBerry/i.test(u),
      isSafari: !!uLower.match(/version\/([\d.]+).*safari/),
      isOpera: !!uLower.match(/opera.([\d.]+)/),
      isChrome: !!uLower.match(/chrome\/([\d.]+)/),
      isFirefox: !!uLower.match(/firefox\/([\d.]+)/),
      isEdge: !!uLower.match(/edge\/([\d.]+)/),
      isIE:
        !!uLower.match(/msie ([\d.]+)/) ||
        !!uLower.match(/rv:([\d.]+)\) like gecko/)
    };
  },

  formatEffectList(effectList: any[]): any[] {
    let newEffect = []
    while(effectList.length > 0) {
      newEffect.push(effectList.splice(0, 3))
    }
    return newEffect
  },

  getLanguage(): string {
    return "en_US"
  },
  
  getCookie(name: string) {
    const value = '; ' + document.cookie
    const parts  = value.split('; ' + name + '=')
    if (parts.length === 2) {
      return parts.pop()!.split(';').shift()
    } else if (name === 'locale') {
      return this.getBorwserlanguage()
    }
  },
  // 获取浏览器语言
  getBorwserlanguage (): LANGUAGE_TYPE {
    const lang = (navigator.language || '').toLocaleLowerCase()
  
    // 单独处理西班牙语
    if (/^es/.test(lang)) {
      return LANGUAGE_TYPE.EN_US
    }
    switch (lang) {
      // 日语
      case 'ja':
        return LANGUAGE_TYPE.JA_JP
      // 简体中文
      case 'zh-cn':
      case 'zh':
        return LANGUAGE_TYPE.ZH_CN
      //繁体中文
      case 'zh-tw':
        return LANGUAGE_TYPE.ZH_TW
      case 'en': //英文
      case 'en-us': //英文(美国)
        return LANGUAGE_TYPE.EN_US
      case 'es': // 西班牙语
        return LANGUAGE_TYPE.EN_US
      case 'pt': //葡萄牙
      case 'pt-br': //葡萄牙(巴西)
      case 'pt-pt': //葡萄牙(葡萄牙)
        return LANGUAGE_TYPE.PT_BR
      case 'fr': // 法语
      case 'fr-fr': // 法语(法国)
      case 'fr-ca': // 法语(加拿大)
      case 'fr-ch': // 法语(瑞士)
        return LANGUAGE_TYPE.FR_FR
      case 'de': // 德语
      case 'de-at': // 德语（奥地利）
      case 'de-de': // 德语（德国）
      case 'de-li': // 德语（列支敦士登）
      case 'de-ch': // 德语（瑞士）
        return LANGUAGE_TYPE.DE_DE
      case 'ru': // 俄语
        return LANGUAGE_TYPE.RU_RU
      default:
        // if (IS_CN) {
        //   return LANGUAGE_TYPE.ZH_CN
        // } else {
        return LANGUAGE_TYPE.EN_US
        // }
    }
  },
  
  selectImageFile ({accept = ".jpg,.jpeg,.png", multiple = true}: uploadProps): Promise<Array<File>> {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = accept;
      input.multiple = multiple;
      input.style.display = "none";
      document.body.append(input);
      input.onchange = (e) => {
        if (e.target) {
          resolve((e.target as any).files);
        } else {
          resolve([]);
        }
        input.remove();
      };
      input.click();
    })
  },

  getImageFromFile(file: File) : Promise<{canvas: HTMLCanvasElement, acturalSize: Size, currentSize: Size}>{
    return new Promise((resolve, reject) => {
      let _this = this
      let image = document.createElement("img")
      image.setAttribute("crossOrigin",'Anonymous')
      image.src = window.URL.createObjectURL(file);
      image.onload = function() {
        let { width, height } = image
        let acturalSize = {width, height}
        let newWidth = Math.round(_this.aspectFillScale(width, height, 720) * width)
        let newHeight = Math.round(_this.aspectFillScale(width, height, 720) * height)
        const canvas = document.createElement("canvas")
        canvas.width = newWidth
        canvas.height = newHeight
        const ctx = canvas.getContext("2d")
        ctx!.drawImage(image, 0, 0, width, height, 0, 0, newWidth, newHeight)
        let currentSize = {width: newWidth, height: newHeight}
        window.URL.revokeObjectURL(image.src)
        resolve({ canvas, acturalSize, currentSize});
      };
    });
  },

  getImageFromUrl(url: string) : Promise<{image: HTMLImageElement}>{
    return new Promise((resolve, reject) => {
      let image = document.createElement("img")
      image.setAttribute("crossOrigin",'Anonymous')
      image.src = url;
      image.onload = function() {
        resolve({ image });
      };
    });
  },
  getOldCookie(name: string) {
    var strCookie = document.cookie;
    var arrCookie = strCookie.split("; ");
    for (var i = 0; i < arrCookie.length; i++) {
      var arr = arrCookie[i].split("=");
      if (arr[0] === name)
        try {
          return decodeURI(this.decodeUTF8(arr[1]));
        } catch (e) {
          return this.decodeUTF8(arr[1]);
        }
    }
    return "";
  },
  decodeUTF8(str: any) {
    return str.replace(/(\\u)(\w{4}|\w{2})/gi, function($0: any, $1: any, $2: string) {
      return String.fromCharCode(parseInt($2, 16));
    });
  },
  base64ToUint8Array(base64: string) : Uint8Array {
    let binary_string = window.atob(base64);
    let len = binary_string.length;
    let bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
        bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes;
  },
  aspectFitScale(width: number, height: number, maxSide: number) {
    let scaleX: number = maxSide / width;
    let scaleY = maxSide / height;
    let scale = Math.min(scaleX, scaleY);
    return scale;
  },
  aspectFillScale(width: number, height: number, minSide: number) {
    let scaleX: number = minSide / width;
    let scaleY = minSide / height;
    let scale = Math.max(scaleX, scaleY);
    return scale;
  },
  checkFileType(file: File) {
    switch (file.type) {
      case "image/png":
      case "image/jpeg":
        return true
      default:
        if(["jpg", "png", "jpeg"].includes(file.name.slice(file.name.lastIndexOf(".")).toLocaleLowerCase())) {
          return true
        }
        return false
    }
  },
  dataURItoBlob(dataURI: string): Blob{
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]; // mime类型
    var byteString = atob(dataURI.split(',')[1]); //base64 解码
    var arrayBuffer = new ArrayBuffer(byteString.length); //创建缓冲数组
    var intArray = new Uint8Array(arrayBuffer); //创建视图

    for (var i = 0; i < byteString.length; i++) {
        intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([intArray], {type: mimeString});
  },
  toFixed(num: number, fix: number = 0): string {
    if(typeof num === "number") {
      return num.toFixed(fix)
    }
    return num
  }
}


export default utils

export function cloneCanvas(oldCanvas: HTMLCanvasElement) {
  //create a new canvas
  let newCanvas = document.createElement("canvas");
  let context = newCanvas.getContext("2d")!;

  //set dimensions
  newCanvas.width = oldCanvas.width;
  newCanvas.height = oldCanvas.height;

  //apply the old canvas to the new one
  context.drawImage(oldCanvas, 0, 0);

  //return the new canvas
  return newCanvas;
}

//打开或下载app
export function openOrDownloadApp(
  appStoreUrl: string,
  client: any = utils.myBrowserOS(),
  schema = "fotor://"
) {
  let { android, ios } = client;

  const gotoDownload = () => {
    window.location.href = appStoreUrl;
  }
  if (ios) {
    // ios 直接去下载地址,不用打开app
    gotoDownload();
    // //ios使用通用链接调起 app
    // window.location.href =
    //   iosUniversalLinks +
    //   "?furl=" +
    //   encodeURIComponent(schema) +
    //   "&downloadNow=" +
    //   encodeURIComponent(appStoreUrl);
  } else if (android) {
    //调起app
    window.location.href = schema;
    //转到下载页
    gotoDownload();
    // //3秒后 执行 [转到下载] 任务
    // let downloadTimer = setTimeout(() => {
    //   gotoDownload();
    // }, 3000);
    // //如果app被成功调起，visibilitychange 事件会被触发。
    // document.addEventListener(
    //   "visibilitychange",
    //   function run() {
    //     console.log("触发 visibilitychange", new Date().toString());
    //     document.removeEventListener("visibilitychange", run, false);
    //     clearTimeout(downloadTimer); //清除 [转到下载] 任务
    //   },
    //   false
    // );
  } else {
    gotoDownload();
  }
}

function getDeepLink(linkKey: string, client: any = utils.myBrowserOS()) {
  // console.log("打开deeplink", linkKey, new Date().toString());
  const storeLink = deeplink[client.ios ? "ios" : "android"];
  return storeLink[linkKey];
}

//打开app 或 通过deeplink下载app
export function openAppOrToDeeplink(
  linkKey: string,
  client: any = utils.myBrowserOS(),
  schema = "goart://"
) {
  openOrDownloadApp(getDeepLink(linkKey, client), client, schema);
}

// 设置localStorage
export const FTSaveLocalData = (key: string, value: any) => {
  if (!key) return;
  if (!value) {
    window.localStorage.removeItem(key);
    return;
  }
  if (typeof value !== "string") {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(key, value);
};
export const FTGetLocalData = (key: string) => {
  if (typeof window.localStorage.getItem(key) !== "undefined") {
    try {
      return JSON.parse(window.localStorage.getItem(key)!);
    } catch (e) {
      return window.localStorage.getItem(key);
    }
  }
  return null;
};

export const getAIGCLink = (type: "textToImage"|"imageToImage") => {
  const typeMap = {
    // textToImage: "creating",
    // imageToImage: "cartoon"
    textToImage: "text",
    imageToImage: "image"
  }
  // return `${urls.baseUrl}features/ai-image-generator/?tooltype=${typeMap[type]}`
  // return `${urls.baseUrl}images/create/?tooltype=${typeMap[type]}`
  return `${urls.baseUrl}images/create?type=${typeMap[type]}&utm_source=goart`
}



/**
 * 初始人机验证获得token 与后端交互
 * @param actionName 行为名称
 * @param callback 回调
 */
export function recaptchaReady(actionName:string):Promise<string> {
	const windows: any = window;
	return new Promise((resolve,reject)=>{
    if (
      windows.grecaptcha &&
      windows.grecaptcha.enterprise &&
      windows.grecaptcha.enterprise.ready
    ) {
      windows.grecaptcha.enterprise.ready(function () {
        windows.grecaptcha.enterprise
          .execute('6LcxshocAAAAAG4Xpw7Mg1CJdycEUyPdXSeF2ToU', {
            action: actionName,
          })
          .then(function (token:string) {
            resolve(token)
          }).catch((error:any)=>{
            reject()
          });
      });
    }
    else{
      reject()
    }
  })
}


/**
 * 渲染人机验证
 * @param {*} domId domId
 * @param {*} verifyCallback 验证回调
 */
export function renderRecaptcha(domId:string, verifyCallback:(token:string)=>void) {
	const windows: any = window;
	if (
		windows.grecaptcha &&
		windows.grecaptcha.enterprise &&
		windows.grecaptcha.enterprise.render
	) {
		const domBox = document.getElementById(domId);

		if (domBox) {
			let id = windows.grecaptcha.enterprise.render(domId, {
				sitekey: '6Lfa4BwcAAAAACLfJjPNBjn-aOkRR-P2EEXL9Sdm',
				callback: verifyCallback,
			});
			return id;
		}
	}
}


export const 	createRecaptcha = () => {
  return new Promise((resolve, reject) => {
    const scriptRecaptcha = document.createElement('script');
    scriptRecaptcha.type = 'text/javascript';
    scriptRecaptcha.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=explicit`;
    // scriptRecaptcha.async = true;
    // scriptRecaptcha.defer = true;
    let all = 0;
    scriptRecaptcha.onload = () => {
      all++;
      if (all === 2) {
        resolve(true);
      }
    };
    document.head.append(scriptRecaptcha);
    // if (
    //   window.grecaptcha &&
    //   window.grecaptcha.enterprise &&
    //   window.grecaptcha.ready
    // ) {
    //   return
    // }
    const scriptRecaptcha2 = document.createElement('script');
    scriptRecaptcha2.type = 'text/javascript';
    scriptRecaptcha2.src = `https://www.recaptcha.net/recaptcha/enterprise.js?render=6LcxshocAAAAAG4Xpw7Mg1CJdycEUyPdXSeF2ToU`;
    // scriptRecaptcha2.async = true;
    // scriptRecaptcha2.defer = true;
    scriptRecaptcha2.onload = () => {
      all++;
      if (all === 2) {
        resolve(true);
      }
    };
    document.head.append(scriptRecaptcha2);
  });
};




export function getUploadUrl():Promise<{uploadUrl:string, key:string}> {
  return new Promise((resolve,reject) => {
    FTGetImageUrl().then(res => {
      if (res.code === '000') {
        resolve(res.data);
      }
      else{
        reject()
      }
    }).catch(error=>{
      reject()
    })
  });
}




interface UploadParam {
  contentType: string;
  url: string;
  file: File;
}
// 上传文件到oss 需要用户 token 验证
function putFileToOss(
  { contentType, url, file }: UploadParam,
  onUploadProgress: any
) {
  let userInfo = FTGetLocalData("fotor_common_user_Info");
  let userToken = userInfo && (userInfo.fotorToken || userInfo.token);
  let headers = {};
  if (!userToken) {
    headers = {
      "Content-Type": contentType,
    };
  } else {
    headers = {
      "Content-Type": contentType,
      "x-oss-meta-author": userToken,
    };
  }
  return defaultAxios({
    method: "PUT",
    url,
    data: file,
    headers: headers,
    onUploadProgress,
    withCredentials: false,
  });
}


export function uploadS3File(url: string,image:File) {
  return new Promise((resolve,reject) => {
    putFileToOss(
      {
        contentType: 'image/jpeg',
        url: url,
        file: image,
      },
      undefined
    )
      .then(res => {
        if (res?.status === 200) {
          resolve(true);
        }
        else{
          reject();
        }
      })
      .catch(() => {
        reject();
      });
  });
}


export function hanldelFTUserProfile(){
  FTUserProfile('c1c4d9514b5c4efe9943e6ac62cef9b4')
}